import { fetchTransactionsPage, makeTransactionsByPageSelector, transactionIdsByPageSelector } from '@ogsnetwork/opp-redux-lib';
import { useCallback, useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from './index';
import { getLastLoadedPage } from './utils/pagination';
export function useTransactions(props) {
    const dispatch = useAppDispatch();
    const transactionsByPageSelector = useMemo(makeTransactionsByPageSelector, [props.page]);
    const transactions = useAppSelector((state) => transactionsByPageSelector(state, { page: props.page }));
    const transactionsByPage = useAppSelector(transactionIdsByPageSelector);
    const { hasNextPage, status } = useAppSelector((state) => state.transactions);
    const dispatchFetchPage = useCallback(() => dispatch(fetchTransactionsPage(props.page)), [props.page]);
    useEffect(() => {
        dispatchFetchPage();
    }, [props.page]);
    return {
        hasNextPage: props.page < getLastLoadedPage(transactionsByPage) || hasNextPage,
        status,
        transactions,
        dispatchFetchPage
    };
}
